import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { PontoFidelidade } from '../models/ponto-fidelidade';

@Injectable({
  providedIn: 'root'
})
export class FidelidadePontoService {

  constructor(private http: HttpClient) {

  }

  consultar() {
    return this.http.get<PontoFidelidade[]>(globals.apiUrl + '/api/FiPonto/Lista');
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, regra) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('regra', regra);
    return this.http.get<any>(globals.apiUrl + '/api/FiPonto/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<PontoFidelidade>(globals.apiUrl + '/api/FiPonto/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(ponto: PontoFidelidade) {
    return this.http.post(globals.apiUrl + '/api/FiPonto/Salvar', ponto);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/FiPonto/Excluir',
      { params: new HttpParams().set('id', id) });
  }

}
